<template>
  <v-main>
    <v-container class="fill-height grey-background" fluid>
      <v-row>
        <v-col>
          <login class="mx-auto"></login>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
  import Login from "../components/Home/Login";

  export default {
    mounted() {
      if (this.$store.getters["user/isLoggedIn"] === true) {
        this.$router.push({ name: "Companies" });
      }
    },
    components: {
      Login,
    },
  };
</script>
<style lang="scss" scoped>
  .grey-background {
    background: #eeeeee;
  }
</style>
